import { FaSitemap, FaUserCircle } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function RosterType() {
  const location = useLocation();
  scrollTo(top);
  return (
    <div className="card-body pt-2 bg-white rounded ">
      <h1 className="mb-4">
        <FormattedMessage id="choose_account_type" />
      </h1>
      <div className="row d-flex my-5">
        <div className="col-md-3">
          <Link
            to={
              location.pathname.includes('admin')
                ? '/admin/rosters/individual_apply'
                : '/rosters/individual_apply'
            }
            className="card d-flex align-items-center roster_type_card  pt-3 border border-primary text-center">
            <FaUserCircle size={100} className="mb-3" />
            <p>
              <FormattedMessage id="individual" />
            </p>
          </Link>
        </div>
        <div className="col-md-3">
          <Link
            to={
              location.pathname.includes('admin')
                ? '/admin/rosters/organization_apply'
                : '/rosters/organization_apply'
            }
            className="card d-flex align-items-center roster_type_card  pt-3 border border-primary text-center">
            <FaSitemap size={100} className="mb-3" />
            <p>
              <FormattedMessage id="organization" />
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RosterType;
